var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("함께하는 사람들")])]), _c('v-tabs', {
    attrs: {
      "grow": "",
      "hide-slider": ""
    }
  }, [_c('v-tab', {
    on: {
      "click": function ($event) {
        return _vm.scrollToSection('association');
      }
    }
  }, [_vm._v("위드캔 후원회")]), _c('v-tab', {
    on: {
      "click": function ($event) {
        return _vm.scrollToSection('ambassador');
      }
    }
  }, [_vm._v("위드캔 엠버서더")]), _c('v-tab', {
    on: {
      "click": function ($event) {
        return _vm.scrollToSection('corporate');
      }
    }
  }, [_vm._v("후원사")])], 1)], 1)], 1), _c('section', {
    staticClass: "client-section pt-0",
    attrs: {
      "id": "association"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('p', {
    staticClass: "client-title--sm font-weight-medium primary--text line-height-15"
  }, [_vm._v("With Aid Association")]), _c('h2', {
    staticClass: "section-title"
  }, [_vm._v("함께하는 후원회")]), _c('p', {
    staticClass: "section-subtitle grey-1--text"
  }, [_vm._v(" 위드캔 후원회는 초저출생 고령화시대 대두되는 다양한 가정 문제 해결과 아동의 인권을 존중하며 아동이 건강하고 안전하게 성장하고, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 자신의 꿈을 펼칠 수 있는 사회 환경을 조성한다는 목적으로 연간 일정 금액 이상을 정기 후원 및 일시 납부하는 개인 후원자의 자발적 모임입니다. ")])]), _c('v-card', {
    staticClass: "people-card",
    attrs: {
      "color": "primary",
      "flat": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/about/people/association.webp",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "people-card__text"
  }, [_c('v-card-title', {
    staticClass: "justify-center white--text line-height-14"
  }, [_c('div', {
    staticClass: "client-title font-size-md-36 text-center"
  }, [_vm._v(" 위드캔 후원회 관련상담 "), _c('br', {
    staticClass: "d-md-none"
  }), _vm._v(" 02-2057-2296 ")])])], 1)], 1)], 1)], 1), _c('section', [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-img', {
    staticClass: "border-radius-16",
    attrs: {
      "src": "/images/about/people/association-1.jpg",
      "alt": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-img', {
    staticClass: "border-radius-16",
    attrs: {
      "src": "/images/about/people/association-2.jpg",
      "alt": ""
    }
  })], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "client-title--lg text-center"
  }, [_vm._v(" 2025년 사회복지법인 위드캔복지재단 "), _c('br'), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("‘함께하는(With-CAN)후원회’ 명단")])])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('people-supporters')], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "client-section",
    attrs: {
      "id": "ambassador"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('p', {
    staticClass: "client-title--sm font-weight-medium primary--text line-height-15"
  }, [_vm._v("With Ambassador")]), _c('h2', {
    staticClass: "section-title"
  }, [_vm._v("함께하는 앰버서더")])]), _c('v-row', _vm._l(_vm.ambassadors, function (ambassador, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "lg": "4"
      }
    }, [_c('v-card', {
      staticClass: "mx-auto h-100",
      attrs: {
        "tile": "",
        "flat": "",
        "max-width": "384"
      }
    }, [_c('v-img', {
      staticClass: "border-radius-16",
      attrs: {
        "src": ambassador.image,
        "alt": ""
      }
    }), _c('v-card-subtitle', {
      staticClass: "pb-0 pt-lg-24"
    }, [_c('div', {
      staticClass: "page-text page-text--lg font-weight-bold primary--text text-center"
    }, [_vm._v(" " + _vm._s(ambassador.job) + " ")])]), _c('v-card-title', {
      staticClass: "pt-8"
    }, [_c('div', {
      staticClass: "tit tit--sm text-center"
    }, [_vm._v(" " + _vm._s(ambassador.name) + " ")])]), _c('v-card-text', {
      staticClass: "pb-36"
    }, [_c('p', {
      staticClass: "page-text page-text--lg text-center",
      domProps: {
        "innerHTML": _vm._s(ambassador.text)
      }
    })])], 1)], 1);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "client-section",
    attrs: {
      "id": "corporate"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('p', {
    staticClass: "client-title--sm font-weight-medium primary--text line-height-15"
  }, [_vm._v("With Corporate partnership")]), _c('h2', {
    staticClass: "section-title"
  }, [_vm._v("함께하는 기업")]), _c('v-btn', {
    staticClass: "mt-24 mt-lg-32",
    attrs: {
      "to": "/guide/company",
      "large": "",
      "outlined": "",
      "color": "primary",
      "rounded": "pill"
    }
  }, [_c('span', {
    staticClass: "page-text page-text--lg primary--text"
  }, [_vm._v("기업후원 더 알아보기")]), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.corporates, function (corporate, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "lg": "4"
      }
    }, [_c('v-card', {
      staticClass: "h-100 mx-auto",
      attrs: {
        "tile": "",
        "flat": "",
        "max-width": "384"
      }
    }, [_c('v-img', {
      staticClass: "border-radius-16",
      attrs: {
        "src": corporate.image
      }
    }), _c('v-card-title', {
      staticClass: "justify-center text-center pb-0 tit tit--sm"
    }, [_vm._v(" " + _vm._s(corporate.title) + " ")])], 1)], 1);
  }), 1), _c('sponsor-slide', {
    staticClass: "pt-60 pt-lg-80"
  })], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }